import { skipToken, useQuery } from '@tanstack/react-query';
import { apiClient } from '#/api/client';

import {
  MESSAGE_TEMPLATE_ENDPOINT_BASE,
  MESSAGE_QUERY_KEY_NAMESPACE,
} from './utils.ts';
import { z } from 'zod';

export const SendResultSchema = z.object({
  totalCount: z.number().int().default(0),
  sentCount: z.number().int().default(0),
  errorCount: z.number().int().default(0),
  sentListUri: z.string().nullable(),
  errorListUri: z.string().nullable(),
});

export type SendResult = z.infer<typeof SendResultSchema>;

async function fetchSendResult(id: string) {
  const response = await apiClient.get(
    `${MESSAGE_TEMPLATE_ENDPOINT_BASE}/${id}/send_result`,
  );

  return response.data;
}

export function useSendResult(enabled: boolean, id?: string) {
  return useQuery({
    queryKey: [MESSAGE_QUERY_KEY_NAMESPACE, 'sendResult', id],
    enabled: !!id && enabled,
    queryFn: id
      ? async () => {
          const response = await fetchSendResult(id);

          const parsed = SendResultSchema.safeParse(response.data);

          if (!parsed.success) {
            console.error(parsed.error);

            throw new Error('Invalid send result response from server');
          }

          return parsed.data;
        }
      : skipToken,
  });
}
